import { render } from "./ViewNoMobileAccess.vue?vue&type=template&id=1de8e8de"
import script from "./ViewNoMobileAccess.vue?vue&type=script&lang=js"
export * from "./ViewNoMobileAccess.vue?vue&type=script&lang=js"

import "./ViewNoMobileAccess.vue?vue&type=style&index=0&id=1de8e8de&lang=scss"

import exportComponent from "/home/s-ol/dot/multi/multi-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__